class Nav {
    shown: boolean;
    breakpoint: number;
    hamburger: any;
    html: any;
    nav: any;
    timeline: any;
    link: any;
    header: any;

    constructor() {

        this.hamburger = document.querySelector('#hamburger');
        this.html = document.querySelector("html");
        this.nav = document.querySelector(".header__menu");
        this.link = document.querySelector("[data-scroll]");
        this.header = document.querySelector("header");

        this.shown = false;

        //viz variables.scss
        this.breakpoint = 901;
        this.timeline = new TimelineMax();

        let previousScrollPosition = window.pageYOffset;

        if (previousScrollPosition >= 100) {
            this.header.style.backgroundColor = "#366072";
        } else {
            this.header.style.backgroundColor = "transparent";
        }

        window.addEventListener('scroll', () => {
            //gsap mi házel nechtěný delay, nevím proč
            let currentScrollPosition = window.pageYOffset;
			if (previousScrollPosition > currentScrollPosition || this.html.classList.contains('show')) {
				this.header.style.top = "0";
			} else if (previousScrollPosition <= currentScrollPosition && currentScrollPosition > 100) {
				this.header.style.top = "-100px";
            }
            if (currentScrollPosition >= 100) {
                this.header.style.backgroundColor = "#366072";
            } else {
                this.header.style.backgroundColor = "transparent";
            }
			previousScrollPosition = currentScrollPosition;
		});


        //toggle menu
        this.hamburger.addEventListener('click', () => {
            this.shown = !!this.html.classList.contains("show");
            if (!this.shown) {
                this.showMenu();
            } else {
                this.hideMenu();
            }
        });

        //back to normal when resize up
        window.addEventListener('resize', () => {
            if (window.innerWidth > this.breakpoint) {
                this.hideMenu();
            }
        });

    }

    public showMenu() {
        this.hamburger.classList.add('close');
        this.html.classList.add('show');

        this.timeline
            .to(this.nav, 0.3, {
                left: "0",
                ease: Power3.easeOut
            });
        this.shown = true;
    };

    public hideMenu() {
        this.timeline
            .to(this.nav, 0.3, {
                left: "100%",
                ease: Power3.easeOut
            });


        this.hamburger.classList.remove('close');
        this.html.classList.remove('show');

        this.shown = false;
    };
}
